import "sitecss/site.css";
import "./fontawesome";
import * as qtipVal from "./jquery.qtip.validation";
import * as toastr from "toastr";

window.toastr = toastr;

declare global {
    interface Window {
        noKendoButtons?: boolean;
        utilLoaded?: boolean;
        postalCodeLookupUrl?: string;
        toastr?: any;
        gridDefaultItemHeight?: any;
        gridTargetHeightAdjustment?: any;
    }
}

declare global {
    interface JQuery {
        getRealDimensions(outer: any): any;
        serializeObject(): any;
        enable(enable: boolean): JQuery;
        textWidth(text: string, font: string): number;
        modalTabbing: () => any;
        addTip(message: string): any;
    }
}


const gridDefaultItemHeight = 41;
const gridTargetHeightAdjustment = 0;
window.gridDefaultItemHeight = gridDefaultItemHeight;
window.gridTargetHeightAdjustment = gridTargetHeightAdjustment;

var noKendoButtons = window.noKendoButtons || false;

export function validationSummary(container, data) {
    if ($("#errorList").length) $("#errorList").remove();
    if (container.find(".custom-message").length) container.find(".custom-message").hide();
    if (data == null) return;

    if (container.find(".custom-message").length) {
        container.find(".custom-message").show();
        return;
    }
    var errorList = $('<ul/>').css("margin-left", "15px");
    $.each(data, function(fieldkey, errors) {
        $.each(errors, function(errorkey, message) {
            $('<li/>')
                .text(message)
                .appendTo(errorList);
        });
    });

    $('<span/>', {
        'id': 'errorList',
        'class': 'error',
        'style': 'display: block;',
        'html': errorList
    }).prependTo(container);
}

export function escapeAttributeValue(value) {
    // As mentioned on http://api.jquery.com/category/selectors/
    return value.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, "\\$1");
}

export function resizeAllDropDowns() {
    $("input[data-role='dropdownlist']").each(function () {
        resizeDropDown($(this));
    });
}

$.fn.getRealDimensions = function(this: JQuery, outer?: boolean): any {
    var $this = $(this);
    if ($this.length == 0) {
        return null;
    }
    var $clone = $this.clone()
        .show()
        .css('visibility', 'hidden')
        .appendTo('body');
    var result = {
        width: (outer) ? $clone.outerWidth() : $clone.innerWidth(),
        height: (outer) ? $clone.outerHeight() : $clone.innerHeight(),
        offsetTop: $clone.offset().top,
        offsetLeft: $clone.offset().left
    };
    $clone.remove();
    return result;
}

function resizeDropDown($dropDown) {
    $dropDown.data("kendoDropDownList").list.width("auto");
    var dataWidth = $dropDown.data("kendoDropDownList").list.getRealDimensions().width - 3,
        listWidth = dataWidth + 20,
        containerWidth = listWidth + 6;

    if (dataWidth == 0) return;
    // Set widths to the new values
    $dropDown.data("kendoDropDownList").list.width(listWidth + 20);
    $dropDown.closest(".k-widget").width(containerWidth + 20);
}

//special validation for use with ajax requests
export function ajaxHeaderToken(): JQuery.PlainObject<string> {
    var headers = { RequestVerificationToken: $('input[name=__RequestVerificationToken]').val() };
    var tokens = $("input[name!='__RequestVerificationToken'][name^='_'][name$='Token']");
    if (tokens.length > 0) {
        var token = (<HTMLInputElement>tokens[0]);
        var tokenName = (<HTMLInputElement>$("input[name!='__RequestVerificationToken'][name^='_'][name$='Token']")[0]).name;
        //var keyName = tokenName.substring(1, tokenName.length - 5);
        //if ($("#" + keyName).length > 0)
        headers[tokenName] = token.value;
    }

    return JSON.parse(JSON.stringify(headers));
}

//if unauthorized during ajax call, refresh page so we get login prompt
$.ajaxSetup({
    statusCode: {
        401: function () {
            window.location.reload();
        }
    }
});

export function maskFields(container) {
    container = container || $(document);
    container.find("input[data-role='maskedtextbox']").each(function () {
        var maskedKendo = $(this).data("kendoMaskedTextBox");
        //re-apply the mask to the field
        if (maskedKendo) maskedKendo.value(maskedKendo.value());
    });
}

export function unmaskFields(container) {
    container = container || $(document);
    container.find("input[data-role='maskedtextbox']").each(function () {
        var maskedKendo = $(this).data("kendoMaskedTextBox");
        if (maskedKendo)
            this.value = maskedKendo.raw();
        else
            this.value = this.value.replace(/\D/g, '');
    });
}


export function moveTip(tipSpan, newFieldName) {
    var tip = tipSpan.detach();
    $("label[for='" + newFieldName + "']").after(tip);
}

export function bottomPosition(div) {
    if (div.length === 0) return 0;
    return div.offset().top + div.outerHeight(true);
}

function closeKendoWindow(evt) {
    var win = $(evt.target).closest(".k-window-content");
    win.data("kendoWindow").close();
}

export function initPartialForm(name, saveUrl, formSel, addEvent, validator) {
    maskFields();
    validator = validator || (() => true);

    var $form = $(formSel);
    $form.on("click", ".cancelButton", (evt) => {
        var form = $(this).closest("form");
        var modalEditCancelEvent = jQuery.Event("modalEditCancel");
        form.trigger(modalEditCancelEvent, evt);
        if (modalEditCancelEvent.isDefaultPrevented()) return false;
        closeKendoWindow(evt);
    });

    $form.on("click", ".saveButton", function (evt) {
        evt.preventDefault();

        var form = $(this).closest("form");

        let data = validateAndGetFormFields(form);
        if(data === false) return;

        var modalPreSaveEvent = jQuery.Event("modalEditPreSave");
        form.trigger(modalPreSaveEvent, data);
        if (modalPreSaveEvent.isDefaultPrevented()) return false;

        data = JSON.stringify(data);

        modalSave(saveUrl, data, name, form, function (edata) {
            if (validator(edata)) {
                form.trigger(addEvent, edata);
                var win = form.closest(".k-window-content");
                win.data("kendoWindow").close();
            } else {
                validationSummary($("#errorSection"), edata);
            }
        });
    });
}

export function initNonSubmitForm(name, saveUrl, formSel, addEvent, validator) {
    maskFields();
    validator = validator || (() => true);

    var $form = $(formSel);
    $form.on("click", ".cancelButton", closeKendoWindow);

    $form.on("click", ".saveButton", function(evt) {
        evt.preventDefault();

        let form = $(this).closest("form");

        let data = validateAndGetFormFields(form);
        if(data === false) return;

        kendo.ui.progress($form, false); //put this ahead of the handler so it doesn't turn off one set in handler
        if(validator(data)) {
            $form.trigger(addEvent, data);
            let win = $form.closest(".k-window-content");
            win.data("kendoWindow").close();
        } else {
            validationSummary($("#errorSection"), data);
        }

    });
}

// Gets the form field values as a serializedObject. Returns boolean false if the fields have not validated.
export function validateAndGetFormFields(form) {
    let inputs =  form.find("input,select,textarea");
    unmaskFields(form);
    if(!isGroupValid(inputs)) return false;

    let data = inputs.serializeObject();
    maskFields(form);
    // This ensures that we are not sending blank strings where we really want to preserve nulls in the model.
    // We can filter out the empty strings at this point, as validation has already ensured the right things are not blank/null.
    for(let key in data) {
        if(data.hasOwnProperty(key) && !data[key]) delete data[key];
    }

    return data;
}

export function modalEditor(url, title, name, progressContainer, events, contentLoaded, autoinit = null, validator = null, closeHandler = null) {
    if (progressContainer) kendo.ui.progress(progressContainer, true);
    contentLoaded = contentLoaded || (() => { });
    events = events || {};
    autoinit = autoinit || true;
    closeHandler = closeHandler || (evt => {
        var container = $(evt.sender.element);
        removeTips(container);
        var win = container.closest(".k-window-content");
        win.data("kendoWindow").destroy();
    });
    var lcname = name.toLowerCase();
    var formselector = "#" + name + "Form";
    var kwindow = $("<div id='" + lcname + "Window'/>");
    kwindow.kendoWindow({
        visible: false,
        modal: true,
        title: title,
        content: url,
        activate: evt => {
            fixModalTabOrder($(evt.sender.element));
        },
        close: closeHandler,
        refresh: function () {
            $(formselector).find("input[type='submit'],button").addClass("k-button");
            qtipVal.parseDynamicContent(formselector);
            $(events).each(function () {
                $(formselector).on(this.Name, this.Method);
            });
            if (autoinit === true) initPartialForm(name, url.split("?")[0], "#" + name + "Form", lcname + "Added", validator);
            else if (typeof autoinit == "function") autoinit(name, url.split("?")[0], "#" + name + "Form", lcname + "Added", validator);
            setTimeout(() => {
                this.center();
                this.open();
                contentLoaded(formselector);
                if (progressContainer) kendo.ui.progress(progressContainer, false);
            }, 1000);
        }
    });
}

export function removeTips(container) {
    container.find("input,select").each(function () {
        if ($(this).data("qtip") !== null) {
            $(this).qtip("destroy");
        }
    });
}

export function modalSave(url, datavalue, name, progressContainer, doneHandler) {
    kendo.ui.progress(progressContainer, true);

    $.ajax({
            url: url,
            headers: ajaxHeaderToken(),
            data: datavalue,
            dataType: "json",
            type: "POST",
            contentType: "application/json"
        })
        .done(function(data) {
            kendo.ui.progress(progressContainer, false); //put this ahead of the handler so it doesn't turn off one set in handler
            doneHandler(data);
        })
        .fail(function() {
            validationSummary($("#errorSection"), { "": ["Failed to save " + name + ". Please try again."] });
            kendo.ui.progress(progressContainer, false);
        });
}

export function fixModalTabOrder($form) {
    $form.find("[data-role='numerictextbox']").each(function () {
        var obj = $(this).data("kendoNumericTextBox");
        if (obj) obj.wrapper.find("input").attr("tabindex", obj.element.attr("tabindex"));
    });
    $form.find("[data-role='dropdownlist']").each(function () {
        var obj = $(this).data("kendoDropDownList");
        if (obj) obj.wrapper.attr("tabindex", obj.element.attr("tabindex"));
    });
    $form.find("[data-role='combobox']").each(function () {
        var obj = $(this).data("kendoComboBox");
        if (obj) obj.wrapper.find("input").attr("tabindex", obj.element.attr("tabindex"));
    });
}

export function ajaxDelete(url, id, token, modelType, progressContainer, successHandler, failHandler) {
    failHandler = failHandler || function () { };
    kendo.ui.progress(progressContainer, true);

    $.ajax({
        url: url,
        headers: ajaxHeaderToken(),
        data: {
            id: id,
            _idToken: token
        },
        type: "POST"
    })
        .done(function (ret) {
            if (ret == true) {
                toastr.info(modelType + " has been removed.");
                successHandler();
            } else {
                toastr.error("Unable to delete " + modelType + ". Please try again later.");
                failHandler();
            }
        })
        .fail(function () {
            toastr.error("Unable to delete " + modelType + ". Please try again later.");
            failHandler();
        })
        .always(function () {
            kendo.ui.progress(progressContainer, false);
        });
}

export function ajaxSubmitForm(form, doneMsg?: string, failMsg?:string) {
    let $form = $(form);
    if ($form.length === 0)
        return $.Deferred().reject().promise();

    kendo.ui.progress($form, true);

    let url = $form.attr("action") ?? $form.data().action;
    let data = validateAndGetFormFields(form);
    if (data === false) {
        kendo.ui.progress($form, false);
        return $.Deferred().reject().promise();
    }

    return $.ajax({
            url: url,
            headers: ajaxHeaderToken(),
            data: data,
            dataType: "json",
            type: "POST",
            // contentType: "application/json"
        })
        .done(data => {
            if (!!doneMsg) {
                toastr.info(doneMsg);
            }
            return data;
        })
        .fail(err => {
            console.dir(err);
            if (!!failMsg) {
                toastr.error(failMsg);
            } else {
                return $.Deferred().reject(err);
            }
        })
        .always(() => {
            kendo.ui.progress($form, false);
        });
}

export function disableFields(selector) {
    $(selector).each(function () {
        var $this = $(this);
        if ($this.data("kendoDatePicker")) {
            $this.data("kendoDatePicker").enable(false);
        } else if ($this.data("kendoNumericTextBox")) {
            $this.data("kendoNumericTextBox").enable(false);
        } else {
            $this.attr("disabled", "disabled");
        }
    });
}

export function isGroupValid(items) {
    var isValid = true;

    items.each(function () {
        if (!$(this).valid()) { isValid = false; }
    });

    return isValid;
}

export function enableAllControls($form, enable, clearOnDisable?: boolean) {
    enableControlType($form, enable, "datepicker", "kendoDatePicker");
    enableControlType($form, enable, "numerictextbox", "kendoNumericTextBox");
    enableControlType($form, enable, "dropdownlist", "kendoDropDownList");
    $form.find("input,textarea").prop("disabled", enable === false);
    if (!enable) {
        $form.find("input:not('.k-formatted-value')").addClass("k-state-disabled");
        if (clearOnDisable) $form.find("input").val("");
    } else {
        $form.find("input").removeClass("k-state-disabled");
    }
    //$form.find(".k-button").prop("disabled", enable === false);
    $form.find(".k-button:not('.no-hide'),.hide-on-disable").hide();
}

export function enableControlType($form, enable, role, dataname) {
    $form.find("[data-role='" + role + "']").each(function () {
        if ($(this).data(dataname))
            $(this).data(dataname).enable(enable);
    });
}

export function decodeHtmlString(encodedString) {
    var textArea = document.createElement("textarea");
    textArea.innerHTML = encodedString;
    return textArea.value;
}

export function equalizeHeights(objects) {
    var maxHeight = objects.map(function () {
        return $(this).outerHeight();
    }).get();
    objects.css("min-height", Math.max.apply(null, maxHeight));
}

$.fn.enable = function (enable:boolean) {
    if (enable)
        this.removeAttr("disabled");
    else
        this.attr("disabled", "disabled");

    return this;
}

export function showOverlay(source, height) {
    var d = document.createElement("div");
    $(d).css({
        width: source.width(),
        height: height || source.height(),
        top: source.position().top,
        left: source.position().left
    }).attr("id", "overlay");
    $("body").append(d);
}

export function hideOverlay(delay, callback) {
    callback = callback || (() => {});
    if ($("#overlay").is(":visible")) {
        setTimeout(() => {
            $("#overlay").fadeOut(delay, () => {
                $(document).trigger("overlay-hidden");
                setTimeout(() => { $("#overlay").remove() }, 100);
                callback();
            });
        }, 1);
    } else {
        callback();
        $(document).trigger("overlay-hidden");
    }
}

export function showProgress() {
    window.setTimeout(function () {
        kendo.ui.progress($("body"), true);
    });
}

export function hideProgress() {
    window.setTimeout(function () {
        kendo.ui.progress($("body"), false);
    });
}

var tempOkBox;
var tempYesNoBox;
export function messageBoxOk(title, message, callback) {
    if (message == null) {
        message = title;
        title = false;
    }
    if (title == null) title = false;
    messageBoxOk_New(title, message).then(e => { callback(e); e.close(); });
    return tempOkBox;
}

export function messageBoxYesNo(title, message, yescallback, nocallback) {
    messageBoxYesNo_New(title, message)
        .done(yescallback)
        .fail(nocallback);
    return tempYesNoBox;
}


export function messageBoxOk_New(title, message) {
    var result = $.Deferred();
    tempOkBox = $("<div></div>").kendoDialog({
        title: title,
        content: message,
        actions: [
            {
                text: "Ok",
                primary: true,
                action(e) {
                    result.resolve(e);
                }
            }
        ]

    }).data("kendoDialog").open();
    return result;
}

export function messageBoxYesNo_New(title, message) {
    var result = $.Deferred();
    tempYesNoBox = $("<div></div>").kendoDialog({
        title: title,
        content: message,
        actions: [
            {
                text: "Yes",
                primary: true,
                action(e) {
                    result.resolve();
                }
            }, {
                text: "No",
                action(e) {
                    result.reject();
                }
            }
        ]

    }).data("kendoDialog").open();
    return result;
}

export function enableSerializeObject() {
    $.fn.serializeObject = function () {
        var obj = {};
        var $origForm = $(this);
        var $form = $(this).clone(); //checkboxes consist of a checkbox input and a hidden false value, we need to combine into a single input or serializeArray will return 2 distinct values

        $form.filter("input[type='checkbox']").each(function () {
            var hdn = $form.filter("input[type='hidden'][name='" + $(this).attr("id") + "']");
            hdn.val($(this).is(":checked").toString()); //$(this).remove();
            //$form.remove("#" + $(this).attr("id"));

            $(this).attr("name", "x"); //removing didn't work, so I just renamed it
        });

        $.each($form.serializeArray(), function (i, o) {
            var n = o.name,
                v = o.value;
            obj[n] = obj[n] === undefined ? v : $.isArray(obj[n]) ? obj[n].concat(v) : [obj[n], v];
        });


        var otherfields = $origForm.filter("textarea,select");
        for (var i = 0, l = otherfields.length; i < l; ++i) obj[$(otherfields[i]).attr("Name")] = ($(otherfields[i]).val());
        return obj;
    };
}

export function enableEnterKeypressOnDialog() {
    $(document).keypress(function (e) {
        if (e.which === 13) {
            if ($(".k-dialog button.k-primary .k-windowbutton .k-primary")) {
                $(".k-dialog button.k-primary").click();
            }
        }
    });
}

export function enablePlaceholderDropdown() {
    $(".placeholderdropdown").on("change", function () {
        if ($(this).find("option:selected").val() === "") {
            $(this).addClass("disabled");
        } else {
            $(this).removeClass("disabled");
        }
    });
}

function setupKendoFormControlClasses() {
    $(".k-widget.k-maskedtextbox:not(.custom-focus)").each(function () {
        $(this).find("input").bind("focus", function () {
            var maskedinput = <HTMLInputElement>this;
            var widget = <kendo.ui.MaskedTextBox><unknown>$(maskedinput).data("kendoMaskedTextBox");
            if (widget.raw() == "") {
                setTimeout(function() {
                        maskedinput.setSelectionRange(0, 0);
                    },
                    250);
            }
        });
    });
}


export function enableTextWidth() {
    $.fn.textWidth = function(text?: string, font?: string) {
        var fakeEl = $('<span>').appendTo(document.body);
        var htmlText = text || this.val() || this.text();
        htmlText = fakeEl.text(htmlText).html(); //encode to Html
        htmlText = htmlText.replace(/\s/g, "&nbsp;"); //replace trailing and leading spaces
        fakeEl.html(htmlText).css('font', font || this.css('font'));
        fakeEl.html(htmlText).css('font-family', this.css('font-family'));
        fakeEl.html(htmlText).css('font-weight', this.css('font-weight'));
        fakeEl.html(htmlText).css('font-size', this.css('font-size'));
        fakeEl.html(htmlText).css('letter-spacing', this.css('letter-spacing'));
        var width = fakeEl.width();
        fakeEl.remove();
        return width;
    };
}

export function gridFilterIconFixEvent(offset?) {
    setTimeout(() => gridFilterIconFix(offset), 500);
}

export function gridFilterIconFix(offset?) {
    if (isNaN(offset)) offset = null;

    var headerWrapper = $("<div></div>")
        .css("display", "flex")
        .css("align-items", "end");

    $("th.k-header").wrapInner(headerWrapper);

    $("a.k-grid-filter").each((index, element) => {
        var $e = $(element);

        $e
        .css("position", "relative")
        .css("height", "auto")
        .css("padding", "0")
        .insertAfter($e.next());
    });

    // OR if you want to center vertically
    // var headerWrapper = $("<div></div>")
    //     .css("display", "flex")
    //     .css("align-items", "center");
    //
    // $("th.k-header")
    //     .css("vertical-align", "middle")
    //     .wrapInner(headerWrapper);
    //
    // $("a.k-grid-filter").each((index, element) => {
    //     var $e = $(element);
    //     $e.css("position", "relative")
    //       .insertAfter($e.next());
    // });
}

export function SetAntiforgeryHeader(req: any);
export function SetAntiforgeryHeader(req) {
    req.setRequestHeader("RequestVerificationToken", $("input:hidden[name='__RequestVerificationToken']").val());
    req.setRequestHeader("XSRF-TOKEN", $("input:hidden[name='__RequestVerificationToken']").val());

    var tokens = $("input[name!='__RequestVerificationToken'][name^='_'][name$='Token']");
    if (tokens.length > 0) {
        var token = (<HTMLInputElement>tokens[0]);
        var tokenName = (<HTMLInputElement>$("input[name!='__RequestVerificationToken'][name^='_'][name$='Token']")[0]).name;
        //var keyName = tokenName.substring(1, tokenName.length - 5);
        //req.setRequestHeader(keyName, $("#" + keyName).val());
        req.setRequestHeader(tokenName, token.value);
    }
};

export function enableModalTabbing() {
    $.fn.modalTabbing = function(this: JQuery): any {
        var $this = $(this);
        var tabbing = function(jqSelector) {
            var inputs = $(jqSelector).find('select, input, textarea, button, a[href]').filter(':visible').not(':disabled');

            //Focus to first element in the container.
            inputs.first().focus();

            $(jqSelector).on('keydown',
                function(e) {
                    if (e.which === 9) {

                        var inputs = $(jqSelector).find('select, input, textarea, button, a[href]').filter(':visible').not(':disabled');

                        /*redirect last tab to first input*/
                        if (!e.shiftKey) {
                            if (inputs[inputs.length - 1] === e.target) {
                                e.preventDefault();
                                inputs.first().focus();
                            }
                        }
                        /*redirect first shift+tab to last input*/
                        else {
                            if (inputs[0] === e.target) {
                                e.preventDefault();
                                inputs.last().focus();
                            }
                        }
                    }
                });
        };

        return $this.each(function() {
            tabbing(this);
        });

    };
}

export function displayImage(url, percentage, progressContainer) {
    progressContainer = progressContainer || $("body");
    percentage = percentage || 90;
    kendo.ui.progress(progressContainer, true);

    var kwindow = $("<div id=\"imageDisplayWindow\"/>");
    kwindow.kendoWindow({
        visible: false,
        modal: true,
        //title: false,
        content: {
            template: "<img src=\"" + url + "\" />"
        },
        close: function (evt) {
            var win = kwindow.closest(".k-window-content");
            kwindow.data("kendoWindow").destroy();
        },
        refresh: function () {
            //var win = this;
            setTimeout(function () {
                var img = kwindow.find("img");
                var win = kwindow.closest(".k-window-content").data("kendoWindow");
                img.css("max-height", $(window).height() * (percentage / 100));
                img.css("max-width", $(window).width() * (percentage / 100));
                win.center();
                win.open();
                if (progressContainer) kendo.ui.progress(progressContainer, false);
            },
                1000);
        }
    });
}

export function setTabIndex(obj, tabIndex) {
    obj.attr("tabindex", tabIndex);
    return tabIndex++;
}

export function enableOrClearAllControls($form, enable) {
    enableControlType($form, enable, "datepicker", "kendoDatePicker");
    enableControlType($form, enable, "numerictextbox", "kendoNumericTextBox");
    enableControlType($form, enable, "dropdownlist", "kendoDropDownList");
    $form.find("input").prop("disabled", enable === false);
    if (!enable) {
        $form.find("input:not('.k-formatted-value')").addClass("k-state-disabled");
        $form.find("input").val("");
    } else {
        $form.find("input").removeClass("k-state-disabled");
    }
}

export function setupKendoObjects(force?: boolean) {
    if (!force && !$("#mainContent").is(":visible")) {
        $(document).one("overlay-hidden", null, () => { setupKendoObjects(true) });
        return;
    }

    setupKendoFormControlClasses();
    enablePlaceholderDropdown();
    readOnlyOrClearAllControls($(".read-only"), true);
    autoWidthForDropDownItems();

    if (!(noKendoButtons || false))
        $("input[type='submit'], button").addClass("k-button");
}

export function autoWidthForDropDownItems() {
    $("[data-role='dropdownlist']").each(function () {
        $(this).data("kendoDropDownList").setOptions({
            autoWidth: true
        });
    });
    $("[data-role='combobox']").each(function () {
        $(this).data("kendoComboBox").setOptions({
            autoWidth: true
        });
    });
}

export function readOnlyControlType($form, readonly, role, dataname) {
    $form.find("[data-role='" + role + "']").each(function () {
        if ($(this).data(dataname))
            $(this).data(dataname).readonly(readonly);
    });
}

export function readOnlyOrClearAllControls($form, readonly) {
    readOnlyControlType($form, readonly, "datepicker", "kendoDatePicker");
    readOnlyControlType($form, readonly, "numerictextbox", "kendoNumericTextBox");
    readOnlyControlType($form, readonly, "dropdownlist", "kendoDropDownList");
    $form.find("input").prop("disabled", readonly === false);
    if (!readonly) {
        $form.find("input:not('.k-formatted-value')").addClass("k-state-disabled");
        $form.find("input").val("");
    } else {
        $form.find("input").removeClass("k-state-disabled");
    }
}

$.fn.addTip = function (this: JQuery<HTMLElement>, message: string): any {
    var $this = $(this);
    if ($this.length === 0) { return false; }

    return $this.qtip({
        overwrite: false,
        content: {
            text: message,
            //prerender: true
        },
        position: {
            my: "center left",
            at: "center right",
        },
        show: {
            event: "mouseover"
        }
    });
}

export function addTip(fieldName, message, target) {
    if ($("#" + fieldName + "Tip").length === 0) {
        target = target || $("label[for=\"" + fieldName + "\"]");
        target.after("<span id=\"" + fieldName + "Tip\"><i class=\"far fa-question-circle tip\"></i></span>");
    }

    var field = $("#" + fieldName + "Tip");
    field.qtip({
        overwrite: true,
        content: {
            text: message
            //prerender: true
        },
        position: {
            my: "center left",
            at: "center right",
        },
        show: {
            event: "mouseover"
        }
    });

    return field;
}

export function autoselectFields(selector) {
    $(document).on("focus", selector, function () {
        var input = $(this);
        clearTimeout(input.data("selectTimeId")); //stop started time out if any

        var selectTimeId = setTimeout(function () {
            input.select();
            // To make this work on iOS, too, replace the above line with the following one. Discussed in https://stackoverflow.com/q/3272089
            // input[0].setSelectionRange(0, 9999);
        });

        input.data("selectTimeId", selectTimeId);
    }).blur(function (e) {
        clearTimeout($(this).data("selectTimeId")); //stop started timeout
    });
}

export function pascalToKebabCase(val: string) : string {
    return val.split(/(?=[A-Z])/).join("-").toLowerCase();
}

export function getEnumNameFromValue(enumObj: object, val: number): string {
    return Object.keys(enumObj).find(name => enumObj[name] === val).split(/(?=[A-Z])/).join(" ");
}

export function disableScopes() {
    $("[disabled-scope]").each(function () {
        // disable all controls
        $(this).find("input, select, textarea, button").attr("disabled", "disabled");
        $(this).find(".k-slider").css("pointer-events", "none");
        $(this).css("opacity", "0.8");
    });
}
